interface SearchableTeam {
  name?: string | null
  organization?: { name?: string | null } | null
  last_competition?: { name?: string | null } | null
}

/**
 * The text a team dropdown option matches a search against: the team name,
 * plus its organization and last competition when the payload carries them —
 * so "winter" finds every team that played Winter Hockey.
 */
export const buildTeamSearchText = (team: SearchableTeam): string =>
  [team.name, team.organization?.name, team.last_competition?.name]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

/** Case-insensitive match of a typed query against `buildTeamSearchText`. */
export const matchesTeamSearch = (
  query: string | null | undefined,
  searchText: string | null | undefined
): boolean => {
  const needle = query?.trim().toLowerCase()
  if (!needle) {
    return true
  }
  return (searchText ?? '').includes(needle)
}
